import * as React from 'react';
import type {
  UserActionSuggestion,
  ActionType,
} from '../../MedicareProAPI/Entities/User/UserActionSuggestion';
import {
  ACTION_TYPES,
  STATUS_TYPES,
  StatusType,
} from '../../MedicareProAPI/Entities/User/UserActionSuggestion';

interface ActionSuggestionProps {
  userAccessToken: string;
  userId: number;
  agencyId?: number;
  suggestion: UserActionSuggestion;
  isUpdating?: boolean;
  onActionClick?: (id: number, actionType: ActionType) => void;
}

/**
 * Component for a single userActionSuggestion
 *
 * @component
 * @author Andrew Brown <abrown@medicareprocrm.com>
 * @date Created: 2025-12-04
 * @lastUpdated
 * @version 1.1.0
 */
export const ActionSuggestion = ({
  userAccessToken,
  userId,
  agencyId,
  suggestion,
  isUpdating,
  onActionClick,
}: ActionSuggestionProps) => {
  return (
    suggestion.getStatus() === STATUS_TYPES.PENDING && (
      <div className="ai-suggestions mb-3">
        <div className="ai-suggestions__header">
          <span className="ai-suggestions__pill border border-primary">
            <i className="fal fa-robot mr-1" /> {suggestion.getReferenceType()}
          </span>
          <span className="ai-suggestions__hint ml-2">
            <b>{suggestion.getInd().getIndName()}</b> - {suggestion.getDateTimeCreated()}
          </span>
          <span>{isUpdating && <i className="far fa-spinner fa-spin ml-2"></i>}</span>
        </div>

        <ul className="ai-suggestions__list mt-3">
          <li className="ai-suggestions__item">{suggestion.getSuggestion()}</li>
        </ul>
        <div className="mt-2 ai-suggestions__actions">
          <span
            className="ai-suggestions__pill_lower border border-primary"
            onClick={() => onActionClick(suggestion.getId(), ACTION_TYPES.ACTIVITY)}
          >
            <i className="far fa-tasks mr-1"></i>Activity
          </span>
          <span
            className="ai-suggestions__pill_lower border border-warning ml-2"
            onClick={() => onActionClick(suggestion.getId(), ACTION_TYPES.ALERT)}
          >
            <i className="far fa-bell-on mr-1"></i>Alert
          </span>
          <span
            className="ai-suggestions__pill_lower border border-success ml-2"
            onClick={() => onActionClick(suggestion.getId(), ACTION_TYPES.APPOINTMENT)}
          >
            <i className="far fa-calendar mr-1"></i>Appointment
          </span>
          <span
            className="ai-suggestions__pill_lower border border-danger ml-2"
            onClick={() => onActionClick(suggestion.getId(), ACTION_TYPES.DISMISS)}
          >
            <i className="far fa-times mr-1"></i>Dismiss
          </span>
        </div>
      </div>
    )
  );
};
